import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import PinataLink from '../../../internal/PinataLink'
import styles, { activeLinkTheme } from './styles'

/**
 * Renders a list item with a react-router-dom NavLink.
 * The NavLink is styled based on the provided theme and whether it is active.
 *
 * @param {Object} props - The properties that define the TabItem component.
 * @param {string} props.theme - The theme for the TabItem.
 * @param {string} props.href - The href for the NavLink.
 * @param {string} props.label - The label for the NavLink.
 * @param {function} props.isActive - The function to determine if the NavLink is active.
 * @param {function|Object} props.asLink - The routing component or object to be used - eg react-router-dom NavLink.
 * @returns {ReactElement} The TabItem component.
 */
const TabItem = ({ theme, href, label, isActive, asLink }) => (
  <li className={styles.item}>
    <PinataLink
      to={href}
      className={styles.link}
      activeClassName={cx(styles.activeLink, activeLinkTheme(theme))}
      isActive={isActive}
      as={asLink}>
      {label}
    </PinataLink>
  </li>
)

TabItem.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  theme: PropTypes.string,
  isActive: PropTypes.func,
  asLink: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
}

export default TabItem
